import {useEffect, useState} from 'react'
import {Outlet, useLocation} from 'react-router-dom'
import {HeaderWrapper} from './components/header'
import {RightToolbar} from '../partials/layout/RightToolbar'
import {ScrollTop} from './components/scroll-top'
import {Content} from './components/content'
import {FooterWrapper} from './components/footer'
import {Sidebar} from './components/sidebar'
import {
  DrawerMessenger,
  ActivityDrawer,
  InviteUsers,
  UpgradePlan,
  ThemeModeProvider,
} from '../partials'
import {PageDataProvider} from './core'
import {reInitMenu} from '../helpers'
import {ToolbarWrapper} from './components/toolbar'
import RemovedProductsBlockingModal from '../../app/modules/removed-products-confirmation/components/RemovedProductsBlockingModal'
import {useAuth} from '../../app/modules/auth'
import {checkRemovedProducts} from '../../app/modules/removed-products-confirmation/core/_requests'
import {useIntl} from 'react-intl'

const MasterLayout = () => {
  const location = useLocation()
  const {auth} = useAuth()
  const {locale: language} = useIntl()
  const [showRemovedProductsModal, setShowRemovedProductsModal] = useState(false)

  useEffect(() => {
    reInitMenu()
  }, [location.key])

  // Check for unconfirmed removed products on mount and periodically
  useEffect(() => {
    if (!auth?.token) return

    const checkForRemovedProducts = async () => {
      try {
        const response = await checkRemovedProducts(auth.token, language)
        if (response.data.has_unconfirmed) {
          setShowRemovedProductsModal(true)
        }
      } catch (error) {
        console.error('Error checking for removed products:', error)
      }
    }

    // Check immediately
    checkForRemovedProducts()

    // Check every 30 seconds
    const interval = setInterval(checkForRemovedProducts, 30000)

    return () => clearInterval(interval)
  }, [auth?.token, language])

  return (
    <PageDataProvider>
      <ThemeModeProvider>
        <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
          <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
            <HeaderWrapper />
            <div className='pt-md-20 flex-column flex-row-fluid' id='kt_app_wrapper'>
              {/* <Sidebar /> */}
              <div className='flex-column flex-row-fluid' id='kt_app_main'>
                <div className='d-flex flex-column flex-column-fluid'>
                  <ToolbarWrapper />
                  <Content>
                    <Outlet />
                  </Content>
                </div>
                {/* <FooterWrapper /> */}
              </div>
            </div>
          </div>
        </div>

        {/* begin:: Drawers */}
        {/* <ActivityDrawer />
        <RightToolbar />
        <DrawerMessenger /> */}
        {/* end:: Drawers */}

        {/* begin:: Modals */}
        {/* <InviteUsers />
        <UpgradePlan /> */}
        <RemovedProductsBlockingModal
          show={showRemovedProductsModal}
          onAllConfirmed={() => setShowRemovedProductsModal(false)}
        />
        {/* end:: Modals */}
        <ScrollTop />
      </ThemeModeProvider>
    </PageDataProvider>
  )
}

export {MasterLayout}
